import styled from 'styled-components/macro'

export const Container = styled.div<{ $fluid?: boolean }>`
  padding: 0 var(--container-spacing);
  width: 100%;
  max-width: calc(var(--container-width) + 2 * var(--container-spacing));
  margin: 0 auto;
`

export const ContainerIntro = styled(Container)`
  @media (max-width: 460px) and (orientation: portrait) {
    height: calc(100vh - 8rem);
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`

export const ContainerHeader = styled(Container)`
  max-width: 144rem;
`
